import { z } from 'zod';

/** Membership of this Cognito group grants the `admin` permission (QZ-D18, QZ-D31). */
export const ADMIN_GROUP_NAME = 'admin';

/** The API's cookie-based, unauthorized session endpoints (QZ-D29, QZ-D31). */
export const AUTH_PATHS = {
  session: '/auth/session',
  refresh: '/auth/refresh',
  signOut: '/auth/signout',
} as const;

/** Returns the signed-in caller's identity (QZ-D31). */
export const ME_PATH = '/me';

/** The body posted to `AUTH_PATHS.session` to start a session from a Cognito refresh token (QZ-D29). */
export const createSessionRequestSchema = z
  .object({
    refreshToken: z.string().min(1),
  })
  .strict();
export type CreateSessionRequest = z.infer<typeof createSessionRequestSchema>;

/** The body returned by `AUTH_PATHS.refresh` (QZ-D29). `expiresAt` is epoch milliseconds. */
export const refreshResponseSchema = z
  .object({
    accessToken: z.string().min(1),
    expiresAt: z.number().int(),
  })
  .strip();
export type RefreshResponse = z.infer<typeof refreshResponseSchema>;

/** The body returned by `ME_PATH` (QZ-D31). */
export const meResponseSchema = z
  .object({
    userId: z.string().min(1),
    email: z.email(),
  })
  .strip();
export type MeResponse = z.infer<typeof meResponseSchema>;
